// extracted by mini-css-extract-plugin
export var card = "_lb-0";
export var content = "_lb-2";
export var details = "_lb-3";
export var icon = "_lb-1";
export var iconBlue = "_lb-5";
export var iconBrand = "_lb-4";
export var iconGrayBlue = "_lb-6";
export var iconGreen = "_lb-7";
export var iconIndigo = "_lb-8";
export var iconOrange = "_lb-9";
export var iconPurple = "_lb-a";
export var iconRed = "_lb-b";
export var iconWarning = "_lb-c";